module.exports = __webpack_public_path__ + "img/ep-L-dosis.7b07a938.jpg";